import { useMutation } from "@tanstack/react-query";
import { Api } from "@/api";
import { filesKeys } from "./keys";

export const useUploadImage = () => {
	const mutation = useMutation({
		mutationFn: Api.Files.postApiFilesImages,
		mutationKey: filesKeys.uploadImage,
		networkMode: "always",
	});
	return { execute: mutation.mutateAsync, isPending: mutation.isPending };
};
